import {
  RECEIVE_FORECAST_DATA,
  RECEIVE_WEATHER_DATA,
  REQUEST_FORECAST_DATA,
  REQUEST_WEATHER_DATA,
} from "../actions/weather";

const DEFAULT_STATE = {};

const weatherReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case REQUEST_FORECAST_DATA:
      return {
        ...state,
        [action.data.id]: {
          ...state[action.data.id],
          forecast: {
            pending: true,
          },
        },
      };

    case RECEIVE_FORECAST_DATA:
      return {
        ...state,
        [action.data.id]: {
          ...state[action.data.id],
          forecast: {
            pending: false,
            data: action.data.forecast,
          },
        },
      };

    case REQUEST_WEATHER_DATA:
      return {
        ...state,
        [action.data.id]: { ...state[action.data.id], pending: true },
      };

    case RECEIVE_WEATHER_DATA: {
      return {
        ...state,
        [action.data.id]: {
          ...state[action.data.id],
          [action.data.period]: action.data.weather.map((v) => {
            v.datetime = new Date(v.datetime).getTime();
            return v;
          }),
          pending: false,
        },
      };
    }

    default:
      return state;
  }
};

export default weatherReducer;
